import styled from 'styled-components';
import { Z_INDEX_HIGH } from '@mews-ui/theme';
import { ANIMATION_CURVE, ANIMATION_DURATION, OPACITY, SPACING } from '@optimus-web/local-tokens';
import { Card } from '../Card';

export interface SkipLinksCardProps {
    showSkipLinks?: boolean;
}

export const SkipLinksCard = styled(Card)<SkipLinksCardProps>`
    z-index: -1;
    top: 0;
    left: -999999px;
    position: fixed;
    opacity: 0;
    transform: translateY(-50%);
    transition: transform ${ANIMATION_DURATION.default}ms ${ANIMATION_CURVE.default};

    ${(props) =>
        props.showSkipLinks &&
        `z-index: ${Z_INDEX_HIGH};
        top: ${SPACING[200]}px;
        left: ${SPACING[200]}px;
        opacity: ${OPACITY.primary};
        transform: translateY(0);`}
`;

export const SkipLinksList = styled.ol`
    padding: 0;
    margin: 0;
    list-style: none;
`;
